import React from 'react';
import { Navbar } from '../../Shared/components/Navbar';
import { LoadingSpinner } from '../../Shared/components/LoadingSpinner';
import { useTier } from '../../../hooks/useTier';
import BillingStatusCard from '../components/BillingStatusCard';
import BillingWarningBanner from '../components/BillingWarningBanner';
import type { BillingActions } from '../../Shared/types';

const EMPTY_BILLING_ACTIONS: BillingActions = {
  can_upgrade: false,
  can_cancel: false,
  can_resume: false,
  show_payment_warning: false,
  show_trial_warning: false,
  show_upgrade_prompt: false,
  upgrade_tiers: [],
};

const BillingPage: React.FC = () => {
  const { subscription, billingActions, isLoading, error, refetch } = useTier();

  return (
    <Navbar>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Billing</h1>

        {billingActions?.show_trial_warning && (
          <div className="mb-6">
            <BillingWarningBanner
              show={true}
              variant="trial"
              trialEndsAt={subscription?.trial_ends_at}
            />
          </div>
        )}

        {billingActions?.show_payment_warning && (
          <div className="mb-6">
            <BillingWarningBanner show={true} />
          </div>
        )}

        {isLoading ? (
          <LoadingSpinner />
        ) : error ? (
          <p className="text-red-600">{error}</p>
        ) : subscription ? (
          <BillingStatusCard
            subscription={subscription}
            billingActions={billingActions ?? EMPTY_BILLING_ACTIONS}
            onRefresh={refetch}
          />
        ) : (
          <p className="text-gray-500">No active subscription found.</p>
        )}
      </div>
    </Navbar>
  );
};

export default BillingPage;
